/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedDescriptionAdditionalOptionsContent_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_user">;
    readonly " $refType": "PdpSharedDescriptionAdditionalOptionsContent_user";
};
export type PdpSharedDescriptionAdditionalOptionsContent_user$data = PdpSharedDescriptionAdditionalOptionsContent_user;
export type PdpSharedDescriptionAdditionalOptionsContent_user$key = {
    readonly " $data"?: PdpSharedDescriptionAdditionalOptionsContent_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDescriptionAdditionalOptionsContent_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDescriptionAdditionalOptionsContent_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '862745f2a8b59e551ecc6367246d0c64';
export default node;
